module.exports = __webpack_public_path__ + "static/media/card-DIN.0b19d166.svg";